// extracted by mini-css-extract-plugin
export default {"doneBtn":"RetailersGatewayPayment_doneBtn__-ND7s","payFields":"RetailersGatewayPayment_payFields__QvkTh"};